const formHelpers = require("./formErrors.js");
const recaptcha = require("google/recaptcha");
const $formElementClass = ".form-control";
const $hpEmailSignUp = $("input[id*='hpEmailSignUp']");
const { setCSRFToken } = require("./utils");

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
const displayMessage = (data, button, scrollableElement) => {
    $.spinner().stop();
    let status;

    if (data.success) {
        status = "btn-success";
        button.addClass(status).text(data.msg);
    }

    if (scrollableElement && data.success) {
        scrollableElement.animate({
            scrollTop: scrollableElement.get(0).scrollHeight
        });
    }
};

/**
* Handles styling based on validity
* @param {object} $form - jQuery form element
* @param {string} status - class to be added to the element
* @param {string} oldstatus - class to be removed from the element
*/
const handleValidity = ($form, status, oldstatus) => {
    if ($form && $form.length) {
        $form.find($formElementClass).each((index, element) => {
            const formGroupSelector = ".form-group";
            const $element = $(element);
            if (oldstatus) {
                $element.parents(formGroupSelector)
                    .removeClass(oldstatus)
                    .addClass(status);
            } else {
                $element.not(`.${status}`).parents(formGroupSelector).removeClass(status);
                $element.filter(`.${status}`).parents(formGroupSelector).addClass(status);
            }
        });
    }
};

/**
* Sets the birthdate input field in the newsletter signup form
* @param {object} $form - jQuery form element
*/
const setBirthdateInput = ($form) => {
    if ($form && $form.length) {
        const day = $form.find("[id*='day']").val();
        const month = $form.find("[id*='month']").val();
        const year = $form.find("[id*='year']").val();
        const birthdate = [month, day, year].join("/");
        $form.find("input[id*='newsletter-birthdate']").val(birthdate);
    }
};

/**
* Initializes the events for the newsletter user consent
*/
export const initNewsletterUserConsentEvents = () => {
    const $acceptNewsletterSubscription = $("input[id*='accept-newsletter-subscription']");
    const $newsletterForm = $acceptNewsletterSubscription.closest("form");
    const $dedicatedNewsletterForm = $("form[id*=dedicated-newsletter-form]");
    const $preferencesPhoneAndSMS = $("input[id*='accept-newsletter-phone'], input[id*='accept-newsletter-sms']");
    const requiredColorClass = "required-color";
    const $newsletterPreferences = $(".newsletter-subscription-preferences");

    if (!$newsletterPreferences.length) {
        return;
    }

    // Reset checkmark on page load
    if ($dedicatedNewsletterForm.length) {
        $dedicatedNewsletterForm.find("input[id*='accept-newsletter-subscription']").prop("checked", false).trigger("change");
        $dedicatedNewsletterForm.find(".newsletter-subscription-preferences .custom-control-input").prop("checked", false).trigger("change");
    }

    // Update required phone if is needed
    if ($newsletterForm.length) {
        const $preferencesPhoneAndSMSChecked = $newsletterForm.find("input[id*='accept-newsletter-phone']:checked, input[id*='accept-newsletter-sms']:checked");

        if ($preferencesPhoneAndSMSChecked.length) {
            const $form = $preferencesPhoneAndSMSChecked.closest("form");
            const $phoneInput = $form.find("input[id*='phone'][type='tel']");
            const $phoneLabel = $phoneInput.parent().find(".form-control-label");
            const phoneRequiredLabel = $phoneInput.data("required-label");

            $phoneInput.addClass("required").attr("placeholder", phoneRequiredLabel).attr("required", true);
            $phoneLabel.addClass(requiredColorClass).text(phoneRequiredLabel);
        }
    }

    $acceptNewsletterSubscription.on("change", function() {
        const $this = $(this);
        const $form = $this.closest("form");
        const $newsletterSubscriptionPreferences = $form.find(".newsletter-subscription-preferences");
        const $acceptNewsletterEmail = $newsletterSubscriptionPreferences.find("input[id*='accept-newsletter-email']");
        const $preferences = $newsletterSubscriptionPreferences.find(".custom-control-input");
        const $phoneInput = $form.find("input[id*='phone'][type='tel']");
        const $phoneLabel = $phoneInput.parent().find(".form-control-label");
        const phoneLabel = $phoneInput.data("label");

        if ($this.is(":checked")) {
            $this.removeClass("is-invalid");
            $newsletterSubscriptionPreferences.removeClass("d-none");
            $acceptNewsletterEmail
                .addClass("disabled")
                .prop("checked", true);
        } else {
            $newsletterSubscriptionPreferences.addClass("d-none");
            $acceptNewsletterEmail.removeClass("disabled");
            $preferences.prop("checked", false);
            $phoneInput.removeClass("required").attr("placeholder", phoneLabel);
            $phoneLabel.removeClass(requiredColorClass).text(phoneLabel);
        }
    });

    $preferencesPhoneAndSMS.on("change", function() {
        const $this = $(this);
        const $form = $this.closest("form");
        const $phoneInput = $form.find("input[id*='phone'][type='tel']");
        const $preferenceSMS = $form.find("input[id*='accept-newsletter-sms']");
        const $preferencePhone = $form.find("input[id*='accept-newsletter-phone']");
        const $phoneLabel = $phoneInput.parent().find(".form-control-label");
        const phoneLabel = $phoneInput.data("label");
        const phoneRequiredLabel = $phoneInput.data("required-label");

        if ($preferencePhone.is(":checked") || $preferenceSMS.is(":checked")) {
            $phoneInput.addClass("required").attr("placeholder", phoneRequiredLabel).attr("required", true);
            $phoneLabel.addClass(requiredColorClass).text(phoneRequiredLabel);
        } else {
            $phoneInput.removeClass("required").attr("placeholder", phoneLabel).removeAttr("required");
            $phoneLabel.removeClass(requiredColorClass).text(phoneLabel);
        }
    });
};

export default function () {
    const $dedicatedNewsletterForm = $("#dedicated-newsletter-form");

    // if the form exists reset it
    if ($dedicatedNewsletterForm.length) {
        // form reset
        $dedicatedNewsletterForm.find("input[type='text'], input[type='email']").val("");
    }

    $(".subscribe-email").on("click", function (e) {
        e.preventDefault();
        const $button = $(this);
        const $form = $button.closest("form");
        const formSelector = `form[id='${$form.attr("id")}']`;
        const sourceDetail = $form.parent().data("source-detail");
        const $scrollableForm = $form.closest(".modal").length ? $form : "";
        recaptcha.setToken({ formSelector: formSelector })
            .then(() => setCSRFToken({ $form: $form  }))
            .then(function() {
                if (!$form.find(".collapse").hasClass("show")) {
                    $(".js-fields-toggler").trigger("click");
                } else {
                    $.spinner().start();
                    const $serverErrorField = $(".newsletter-server-error");
                    $serverErrorField.empty();
                    $button.attr("disabled", true);
                    const url = $form.attr("action");
                    setBirthdateInput($form);

                    // Append the sourceDetail to the serialized form data
                    const formData = sourceDetail ? $form.serialize() + "&sourceDetail=" + encodeURIComponent(sourceDetail) : $form.serialize();

                    $.ajax({
                        url: url,
                        type: "post",
                        dataType: "json",
                        data: formData,
                        success: function (data) {
                            if (!data.success) {
                                formHelpers.loadFormErrors($form, data, $scrollableForm);
                                handleValidity($form, "is-invalid");
                                $.spinner().stop();
                                $button.removeAttr("disabled");
                            } else {
                                formHelpers.clearPreviousErrors($form);
                                handleValidity($form, "is-valid", "is-invalid");
                                displayMessage(data, $button, $scrollableForm);
                            }
                        },
                        error: function (err) {
                            $.spinner().stop();
                            $button.removeAttr("disabled");
                            const response = err.responseJSON;
                            if (response.csrfError) {
                                window.location.href = response.redirectUrl;
                            }
                            const message = response.message;
                            if (message) {
                                $serverErrorField.append("<p>" + message + "</p>");
                            }
                        }
                    });
                }
            });
    });

    $(".form-title").on("select2:opening", function () {
        const $this = $(this);
        if ($this.find("option").prop("selected") === true) {
            $this
                .find("option[value='default']")
                .prop("selected", true)
                .trigger("change");
        }
    });

    $hpEmailSignUp.one("click", function () {
        var getAgeGateCookie = ("; " + document.cookie).split("; ageGate=").pop().split(";")[0];
        var codeCountryFromAgeGate = getAgeGateCookie.split("/")[3];
        var wantedCountry = "";
        var $this = $(this);
        var $form = $this.closest("form");
        var $countryField = $form.find("select[id*='-countryField']");

        if (codeCountryFromAgeGate && $countryField.val() === "") {
            $countryField.find("option").each(function () {
                if ($(this).val() === codeCountryFromAgeGate) {
                    wantedCountry = codeCountryFromAgeGate;
                }
            });
            $countryField.val(wantedCountry.trim()).trigger("change");
        }
    });

    $(".anchorNewsletter-focus").on("click", function() {
        $hpEmailSignUp.trigger("click");
    });
}
